interface CountdownPreviewProps {
  props: Record<string, string | number | boolean>
}

export function CountdownPreview({ props }: CountdownPreviewProps) {
  const minutes = (props.minutes as string) || '15'
  const label = (props.label as string) || 'Offer expires in:'

  return (
    <div className="p-4 rounded text-center bg-tf-bg-hover text-tf-text">
      <p className="text-sm mb-2">{label}</p>
      <div className="flex items-center justify-center gap-2 text-2xl font-bold">
        <span>00</span>:<span>{String(minutes).padStart(2, '0')}</span>:<span>00</span>
      </div>
    </div>
  )
}
